import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "../components/Typography";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import img_feature from "../asset/sim_feature.png";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "20px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
    },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignSelf: "center",
    height: "100%",
    justifyContent: "center",
    minHeight: 830,
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxHeight: 1390,
      borderTop: "none",
    },
  },
  topTextBox: {
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    right: 187,
    marginBottom: 20,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 20,
    },
  },

  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {},
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: 560,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      height: 585,
    },
  },
  ImgBox: {
    height: 130,
    background: "#fdf5fd",
    display: "flex",
    justifyContent: "center",
  },
  img: {
    width: "626px",
    height: "335px",
    marginBottom: "55px",
    marginTop: "55px",
    position: "relative",
    bottom: 300,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      bottom: 145,
      width: 300,
      height: 190,
    },
  },
  textContent: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    left: 20,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "0px 20px",
      left: 0,
    },
  },
  textBox: {
    marginBottom: "10px",
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 115,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 112,
    },
  },
}));

export const SimFeaturePage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.topTextBox}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue}
          />
          <Typography variant="H3" className={classes.top_text}>
            심브릿지 시뮬레이션 특장점
          </Typography>
        </div>
        <div className={classes.container}>
          <div className={classes.textContent}>
            <Typography variant="Content1" className={classes.textBox}>
              1) 한국간호교육평가원 표준 학습성과 반영하여 학과 평가 대비 완성
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              2) 학생별 실습 과제 성취 수준 분석 보고서 자동 생성
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              3) 병원 실습에서 접하기 힘든 문제 상황 중심으로 사례를 구성하여
              학생들의 문제해결 능력 향상 도모
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              4) 주요 단계별 디브리핑 기능 추가
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              5) 게시판을 통해 교수자가 추가로 상시 자료 업데이트 가능
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              6) 학생 스스로 자가학습이 가능하도록 단계별 콘텐츠 구성
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              7) 온라인 화상 회의 링킹을 통해 학생과의 소통 및 관리 범위 확장
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              8) 한로 콘텐츠를 제공하여 학생들의 학습 이해도 증가
            </Typography>
          </div>
        </div>
        <div className={classes.ImgBox}>
          <img src={img_feature} alt="img_feature" className={classes.img} />
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};
